import Dashboard2 from "views/Dashboard/Dashboard2";
import UserProfile from "views/UserProfile/UserProfile";
import TableList from "views/TableList/TableList";
import Charts from "views/Charts/Charts";
//import Icons from "views/Icons/Icons";
//import Maps from "views/Maps/Maps";
//import Notifications from "views/Notifications/Notifications";
//import Upgrade from "views/Upgrade/Upgrade";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Panel główny",
    icon: "pe-7s-graph",
    component: Dashboard2
  },

  {
    path: "/charts",
    name: "Wykresy",
    icon: "pe-7s-news-paper",
    component: Charts
  },
  {
    path: "/user",
    name: "Użytkownik",
    icon: "pe-7s-user",
    component: UserProfile
  },
  {
    path: "/table",
    name: "Urządzenia",
    icon: "pe-7s-note2",
    component: TableList
  },

  // {
  //   path: "/notifications",
  //   name: "Ustawienia",
  //   icon: "pe-7s-bell",
  //   component: Notifications
  // },

  { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx